<template>
  <div>
    <div @click="showModal">
      <i class="fa fa-bus mr-2"></i>
      Vaciar todos
    </div>
    <b-modal ref="my-modal" size="sm" hide-footer>
      <div class="d-block">
        <p class="text-xl">
          ¿Seguro que deseas vaciar todos los buses de {{ busTypeName }} del día
          {{ date }} ?
        </p>
      </div>
      <div class="mt-3 text-center">
        <b-button pill variant="ligth" @click="hideModal">
          <i class="fa fa-ban mr-1" aria-hidden="true"></i>Cancelar
        </b-button>
        <b-button
          pill
          variant="dark"
          @click="reseteAllBusesAssigned"
          class="ml-3"
        >
          <i class="fa fa-floppy-o mr-1" aria-hidden="true"></i>Aceptar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    bus_type: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      date: this.$store.getters.filterDate,
    };
  },
  computed: {
    path() {
      if ( this.$route.path == "/app/excursiones/excursiones" )
        return "Excursion"
      else if ( this.$route.path == "/app/excursiones/pickups")
        return "Pickup"
      else if ( this.$route.path == "/app/excursiones/returns" )
        return "Return"
    },
    busTypeName() {
      let bus_type_name = ""
      if ( this.$route.path == "/app/excursiones/excursiones" )
        return "excursión"
      else if ( this.$route.path == "/app/excursiones/pickups")
        return "recogida"
      else if ( this.$route.path == "/app/excursiones/returns")
        return "devolución"
      return bus_type_name;
    },
  },
  methods: {
    async reseteAllBusesAssigned() {
      const busData = {
        date: this.$store.getters.filterDate,
        group: this.$store.getters.filterGroup,
        bus_type: this.path,
      };

      const bookingData = {
        date: this.$store.getters.filterDate,
        group: this.$store.getters.filterGroup,
      };

      let bus_type = "Excursion";
      if (this.$route.path == "/app/excursiones/pickups") {
        bus_type = "Pickup";
      } else if ( this.$route.path == "/app/excursiones/returns" ) {
        bus_type = "Return"
      }
      await this.$store.dispatch("bookingsBus/resetAssignedBusesByType", {
        date: this.date,
        bus_type: bus_type,
      });
      this.$notify({
        group: "foo",
        title: "Vaciado de buses",
        text: "Se han vacíado todos los buses solicitados",
        type: "success",
      });
      this.hideModal();
      this.$store.commit("ISLOADING", ["booking", false], {
        root: true,
      });
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
  },
};
</script>
